import {createModule} from '@Actions/utils';
import  API_ROUTES  from '@Apis/constants';

const getCMV2 = createModule({
    base: 'GET_SEVERITY_NAMES',
    apiDetails: {url: API_ROUTES.CUSTOM_REASON, method: 'get'},
});

export {
    getCMV2
}
